import Vue from 'vue'
import Vuex from 'vuex'

import busy from '@/store/busy'

// Files
import files from '@/store/files'
import filesFolder from '@/store/files/folder'
import filesMedia from '@/store/files/media'
import filesRecent from '@/store/files/recent'
import filesTransfer from '@/store/files/transfer'

import message from '@/store/message'

import modal from '@/store/modal'

import notifications from '@/store/notifications'

import search from '@/store/search'

import select from '@/store/select'

import user from '@/store/user'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    busy,
    files,
    filesFolder,
    filesMedia,
    filesRecent,
    filesTransfer,
    message,
    modal,
    notifications,
    search,
    select,
    user
  }
})
